import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
type PolicyKey = 'privacy' | 'terms' | 'refund' | null;
const policyContent: Record<Exclude<PolicyKey, null>, {
  title: string;
  body: React.ReactNode;
}> = {
  privacy: {
    title: 'Política de Privacidad',
    body: <>
        <p className="text-slate-400 text-sm italic mb-6" data-id="element-57">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 data-id="element-58">1. Información que Recopilamos</h3>
        <p data-id="element-59">
          En El Mapa de la Noche Sin Reflujo recopilamos la información que tú
          nos proporcionas voluntariamente al realizar una compra, incluyendo:
          nombre completo, dirección de correo electrónico, dirección de
          facturación e información de pago (procesada de forma segura por
          nuestros procesadores de pago certificados).
        </p>
        <p data-id="element-60">
          Adicionalmente, recopilamos datos automáticos de navegación como tu
          dirección IP, tipo de navegador, dispositivo utilizado, páginas
          visitadas y tiempo de permanencia, mediante cookies y tecnologías
          similares.
        </p>

        <h3 data-id="element-61">2. Uso de la Información</h3>
        <p data-id="element-62">Utilizamos tu información para:</p>
        <ul data-id="element-63">
          <li data-id="element-64">Procesar y entregar tu compra digital.</li>
          <li data-id="element-65">Enviarte el producto adquirido a tu correo electrónico.</li>
          <li data-id="element-66">Brindarte soporte al cliente cuando lo solicites.</li>
          <li data-id="element-67">
            Enviarte comunicaciones relevantes sobre tu compra y actualizaciones
            del producto.
          </li>
          <li data-id="element-68">
            Mejorar nuestros servicios, contenido y experiencia de usuario.
          </li>
          <li data-id="element-69">Cumplir con obligaciones legales y fiscales.</li>
        </ul>

        <h3 data-id="element-70">3. Compartir Información con Terceros</h3>
        <p data-id="element-71">
          No vendemos, alquilamos ni intercambiamos tu información personal con
          terceros con fines comerciales. Solo compartimos datos con proveedores
          estrictamente necesarios para la operación del servicio, tales como:
        </p>
        <ul data-id="element-72">
          <li data-id="element-73">Procesadores de pago (Stripe, PayPal, Shopify Payments).</li>
          <li data-id="element-74">Plataformas de envío de correo electrónico.</li>
          <li data-id="element-75">Servicios de análisis web (Google Analytics, Meta Pixel).</li>
        </ul>

        <h3 data-id="element-76">4. Cookies</h3>
        <p data-id="element-77">
          Utilizamos cookies para mejorar tu experiencia, recordar tus
          preferencias y analizar el tráfico del sitio. Puedes desactivar las
          cookies desde la configuración de tu navegador en cualquier momento,
          aunque algunas funcionalidades del sitio podrían verse limitadas.
        </p>

        <h3 data-id="element-78">5. Seguridad de los Datos</h3>
        <p data-id="element-79">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información personal contra acceso no autorizado, pérdida,
          alteración o destrucción. Todas las transacciones se realizan mediante
          conexiones cifradas SSL.
        </p>

        <h3 data-id="element-80">6. Tus Derechos</h3>
        <p data-id="element-81">
          Tienes derecho a acceder, rectificar, eliminar u oponerte al
          tratamiento de tus datos personales. Para ejercer cualquiera de estos
          derechos, contáctanos respondiendo al correo de confirmación de tu
          compra.
        </p>

        <h3 data-id="element-82">7. Cambios en esta Política</h3>
        <p data-id="element-83">
          Nos reservamos el derecho de actualizar esta Política de Privacidad en
          cualquier momento. Los cambios entrarán en vigor inmediatamente
          después de su publicación en este sitio.
        </p>
      </>
  },
  terms: {
    title: 'Términos y Condiciones',
    body: <>
        <p className="text-slate-400 text-sm italic mb-6" data-id="element-84">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 data-id="element-85">1. Aceptación de los Términos</h3>
        <p data-id="element-86">
          Al acceder, navegar o realizar una compra en este sitio web, aceptas
          estar legalmente vinculado por estos Términos y Condiciones. Si no
          estás de acuerdo con alguno de los puntos descritos, te pedimos que no
          utilices nuestro sitio ni adquieras nuestros productos.
        </p>

        <h3 data-id="element-87">2. Descripción del Producto</h3>
        <p data-id="element-88">
          "El Mapa de la Noche Sin Reflujo" es un producto digital descargable
          en formato PDF. Incluye una guía principal y materiales
          complementarios (checklists, guías de ingeniería, recetas, hojas de
          trabajo). La entrega se realiza por correo electrónico inmediatamente
          después de completar el pago.
        </p>

        <h3 data-id="element-89">3. Naturaleza Educativa del Contenido</h3>
        <p data-id="element-90">
          El contenido se ofrece exclusivamente con fines educativos e
          informativos. No constituye asesoramiento médico profesional ni
          reemplaza la consulta con un profesional de la salud calificado. Los
          resultados pueden variar según cada persona y no garantizamos
          resultados específicos.
        </p>

        <h3 data-id="element-91">4. Licencia de Uso</h3>
        <p data-id="element-92">
          Al adquirir el producto, obtienes una licencia personal, no exclusiva
          e intransferible para uso individual. Está estrictamente prohibido:
        </p>
        <ul data-id="element-93">
          <li data-id="element-94">Compartir, redistribuir, copiar o revender el contenido.</li>
          <li data-id="element-95">
            Modificar, traducir o crear obras derivadas sin autorización por
            escrito.
          </li>
          <li data-id="element-96">
            Utilizar el contenido con fines comerciales o de capacitación a
            terceros.
          </li>
        </ul>

        <h3 data-id="element-97">5. Propiedad Intelectual</h3>
        <p data-id="element-98">
          Todos los derechos de autor, marcas, textos, imágenes y diseño del
          producto y del sitio web son propiedad exclusiva de El Mapa de la
          Noche Sin Reflujo. Cualquier uso no autorizado constituye una
          violación a la propiedad intelectual.
        </p>

        <h3 data-id="element-99">6. Precios y Pagos</h3>
        <p data-id="element-100">
          Todos los precios están expresados en dólares estadounidenses (USD).
          Nos reservamos el derecho de modificar los precios en cualquier
          momento. Los pagos se procesan a través de plataformas seguras
          (Stripe, PayPal, Shopify Payments).
        </p>

        <h3 data-id="element-101">7. Limitación de Responsabilidad</h3>
        <p data-id="element-102">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes derivados del uso o la imposibilidad de
          usar el producto. El uso de la información contenida es bajo tu propia
          responsabilidad.
        </p>

        <h3 data-id="element-103">8. Modificaciones</h3>
        <p data-id="element-104">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. Los cambios serán efectivos a partir de su
          publicación en el sitio web.
        </p>

        <h3 data-id="element-105">9. Legislación Aplicable</h3>
        <p data-id="element-106">
          Estos términos se rigen por las leyes vigentes en el país de operación
          de la empresa. Cualquier disputa será resuelta en los tribunales
          correspondientes a dicha jurisdicción.
        </p>
      </>
  },
  refund: {
    title: 'Política de Reembolso',
    body: <>
        <p className="text-slate-400 text-sm italic mb-6" data-id="element-107">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 data-id="element-108">🛡️ Garantía de 7 Noches Sin Riesgo</h3>
        <p data-id="element-109">
          En El Mapa de la Noche Sin Reflujo confiamos plenamente en la
          efectividad de nuestro protocolo. Por eso ofrecemos una garantía
          completa de satisfacción de 7 noches a partir de la fecha de compra.
        </p>

        <h3 data-id="element-110">1. Condiciones para Solicitar el Reembolso</h3>
        <p data-id="element-111">
          Para ser elegible para un reembolso completo, debes cumplir con lo
          siguiente:
        </p>
        <ul data-id="element-112">
          <li data-id="element-113">
            Solicitar el reembolso dentro de los 7 días naturales posteriores a
            la fecha de compra.
          </li>
          <li data-id="element-114">
            Haber aplicado el Protocolo 3-2-1 durante al menos 7 noches
            consecutivas.
          </li>
          <li data-id="element-115">
            Enviar tu solicitud al correo electrónico de soporte indicado en tu
            recibo de compra.
          </li>
        </ul>

        <h3 data-id="element-116">2. Proceso de Reembolso</h3>
        <p data-id="element-117">El proceso es simple y sin complicaciones:</p>
        <ol data-id="element-118">
          <li data-id="element-119">
            Envíanos un correo electrónico con tu número de orden y tu correo de
            compra.
          </li>
          <li data-id="element-120">
            No requerimos formularios complicados ni explicaciones extensas.
          </li>
          <li data-id="element-121">
            Procesaremos tu reembolso dentro de un plazo máximo de 5 a 10 días
            hábiles.
          </li>
          <li data-id="element-122">
            El reembolso se acreditará al mismo método de pago utilizado en la
            compra original.
          </li>
        </ol>

        <h3 data-id="element-123">3. Reembolso del 100%</h3>
        <p data-id="element-124">
          Te devolveremos el monto completo de tu compra. Sin preguntas. Sin
          descuentos. Sin retención de tarifas administrativas. Si el producto
          no te funcionó, asumimos todo el riesgo.
        </p>

        <h3 data-id="element-125">4. Casos No Cubiertos</h3>
        <p data-id="element-126">La garantía no se aplica en los siguientes casos:</p>
        <ul data-id="element-127">
          <li data-id="element-128">
            Solicitudes realizadas después de los 7 días naturales de la compra.
          </li>
          <li data-id="element-129">
            Casos de uso fraudulento o redistribución del contenido a terceros.
          </li>
          <li data-id="element-130">
            Reembolsos solicitados sin haber aplicado el protocolo de manera
            consecutiva.
          </li>
        </ul>

        <h3 data-id="element-131">5. Producto Digital</h3>
        <p data-id="element-132">
          Dado que se trata de un producto digital descargable, no es necesario
          "devolver" el archivo. Sin embargo, una vez procesado el reembolso, tu
          licencia de uso se considera revocada y deberás eliminar todas las
          copias del material en tu posesión.
        </p>

        <h3 data-id="element-133">6. Contacto para Reembolsos</h3>
        <p data-id="element-134">
          Para iniciar el proceso de reembolso, responde al correo de
          confirmación que recibiste al momento de tu compra, indicando
          claramente "SOLICITUD DE REEMBOLSO" en el asunto.
        </p>

        <p className="mt-8 p-4 bg-green-950/30 border border-green-900/50 rounded-xl text-green-100" data-id="element-135">
          <strong data-id="element-136">Nuestro compromiso:</strong> Estamos tan seguros del valor de
          este protocolo que asumimos todo el riesgo financiero. Tú solo asumes
          el riesgo de seguir sufriendo cada noche.
        </p>
      </>
  }
};
function PolicyModal({
  policyKey,
  onClose
}: {
  policyKey: PolicyKey;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!policyKey) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEsc);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [policyKey, onClose]);
  if (!policyKey) return null;
  const content = policyContent[policyKey];
  return <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-start sm:items-center justify-center p-0 sm:p-4 overflow-y-auto" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="policy-modal-title" data-id="element-137">
      <div className="bg-slate-900 border border-slate-700 rounded-none sm:rounded-2xl w-full max-w-3xl my-0 sm:my-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-138">
        <div className="sticky top-0 bg-slate-900 border-b border-slate-700 px-6 sm:px-8 py-4 flex items-center justify-between rounded-t-none sm:rounded-t-2xl z-10" data-id="element-139">
          <h2 id="policy-modal-title" className="text-xl sm:text-2xl font-bold text-white" data-id="element-140">
            {content.title}
          </h2>
          <button onClick={onClose} aria-label="Cerrar" className="text-slate-400 hover:text-white p-2 hover:bg-slate-800 rounded-lg transition-colors" data-id="element-141">
            <XIcon size={22} data-id="element-142" />
          </button>
        </div>

        <div className="px-6 sm:px-8 py-6 sm:py-8 prose prose-invert prose-sm sm:prose-base max-w-none policy-body" data-id="element-143">
          {content.body}
        </div>

        <div className="border-t border-slate-800 px-6 sm:px-8 py-4 flex justify-end" data-id="element-144">
          <button onClick={onClose} className="bg-slate-800 hover:bg-slate-700 text-white px-5 py-2 rounded-lg font-medium transition-colors" data-id="element-145">
            Cerrar
          </button>
        </div>
      </div>

      <style data-id="element-146">{`
        .policy-body h3 {
          color: #f59e0b;
          font-weight: 700;
          font-size: 1.05rem;
          margin-top: 1.75rem;
          margin-bottom: 0.75rem;
        }
        .policy-body h3:first-child {
          margin-top: 0;
        }
        .policy-body p {
          color: #cbd5e1;
          line-height: 1.7;
          margin-bottom: 1rem;
          font-size: 0.95rem;
        }
        .policy-body ul, .policy-body ol {
          color: #cbd5e1;
          margin-left: 1.25rem;
          margin-bottom: 1rem;
          line-height: 1.7;
          font-size: 0.95rem;
        }
        .policy-body ul li {
          list-style-type: disc;
          margin-bottom: 0.35rem;
        }
        .policy-body ol li {
          list-style-type: decimal;
          margin-bottom: 0.35rem;
        }
        .policy-body strong {
          color: #ffffff;
        }
      `}</style>
    </div>;
}
export function FooterSection() {
  const currentYear = new Date().getFullYear();
  const [activePolicy, setActivePolicy] = useState<PolicyKey>(null);
  const linkClass = 'text-slate-500 hover:text-slate-300 transition-colors underline underline-offset-4 cursor-pointer';
  return <footer className="border-t border-slate-800 bg-slate-950 py-10 mt-12" data-id="element-147">
      <div className="max-w-[720px] mx-auto px-4 sm:px-6 space-y-8" data-id="element-148">
        {/* Medical Disclaimer */}
        <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-5 sm:p-6" data-id="element-149">
          <h4 className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3" data-id="element-150">
            ⚕️ Descargo de Responsabilidad Médica
          </h4>
          <p className="text-xs text-slate-500 leading-relaxed" data-id="element-151">
            La información contenida en "El Mapa de la Noche Sin Reflujo" tiene
            fines exclusivamente educativos e informativos. No constituye
            consejo médico, diagnóstico ni tratamiento profesional. Este
            producto no pretende sustituir la consulta, el diagnóstico o el
            tratamiento de un profesional de la salud calificado. Siempre
            consulta a tu médico antes de iniciar cualquier programa de salud o
            modificar tu tratamiento actual. Los resultados pueden variar de
            persona a persona. Si experimentas síntomas graves, dolor intenso,
            dificultad para tragar o sangrado, busca atención médica de
            emergencia de inmediato. Este producto no ha sido evaluado por la
            FDA ni por ninguna agencia reguladora de salud.
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm" data-id="element-152">
          <button type="button" onClick={() => setActivePolicy('privacy')} className={linkClass} data-id="element-153">
            Política de Privacidad
          </button>
          <span className="text-slate-700 hidden sm:inline" data-id="element-154">|</span>
          <button type="button" onClick={() => setActivePolicy('terms')} className={linkClass} data-id="element-155">
            Términos y Condiciones
          </button>
          <span className="text-slate-700 hidden sm:inline" data-id="element-156">|</span>
          <button type="button" onClick={() => setActivePolicy('refund')} className={linkClass} data-id="element-157">
            Política de Reembolso
          </button>
        </div>

        {/* Copyright */}
        <div className="text-center space-y-2" data-id="element-158">
          <p className="text-xs text-slate-600" data-id="element-159">
            © {currentYear} El Mapa de la Noche Sin Reflujo. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-slate-700" data-id="element-160">
            Este sitio no forma parte de Facebook, Google ni de ninguna
            plataforma de redes sociales. Además, no está respaldado por
            Facebook, Google ni por ninguna otra plataforma de ninguna manera.
          </p>
        </div>
      </div>

      <PolicyModal policyKey={activePolicy} onClose={() => setActivePolicy(null)} data-id="element-161" />
    </footer>;
}